import { getToken } from "firebase/app-check";
import { getAppCheckInstance } from "./client";

/**
 * Pobiera App Check token żeby dorzucić jako `X-Firebase-AppCheck` header
 * przy fetch'u do Cloud Functions endpoint'ów. Firebase SDK Firestore /
 * Storage / FCM dorzucają tokeny automatycznie — `onRequest` CF nie ma
 * takiej magii, trzeba ręcznie.
 *
 * Zwraca `null` gdy App Check niedostępne (np. emulator, brak window).
 * Caller decyduje co zrobić — nie blokujemy requestu, backend ma 24h
 * grace period (warning, nie 403).
 *
 * `forceRefresh: false` — używa cache'a SDK (1h TTL), refresh tylko gdy
 * przeterminowane. Każdy CF call = jeden in-memory lookup, bez network.
 */
export async function getAppCheckToken(): Promise<string | null> {
  const appCheck = getAppCheckInstance();
  if (!appCheck) return null;
  try {
    const result = await getToken(appCheck, /* forceRefresh */ false);
    return result.token;
  } catch (e) {
    console.warn("[appCheck] getToken failed:", e);
    return null;
  }
}

/**
 * Helper do dorzucenia App Check header (gdy token dostępny). Każdy fetch
 * do CF spreaduje wynik w headers:
 *
 *   const ac = await getAppCheckHeader();
 *   await fetch(url, { headers: { Authorization, ...ac } });
 */
export async function getAppCheckHeader(): Promise<
  Record<string, string>
> {
  const token = await getAppCheckToken();
  return token ? { "X-Firebase-AppCheck": token } : {};
}
